"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useClient = _interopRequireDefault(require("@sprinx/react-api-client/useClient"));

var _ShoppingContext = _interopRequireDefault(require("./ShoppingContext"));

var _mapCustomerToCheckout = _interopRequireDefault(require("./mapCustomerToCheckout"));

var defaultCheckoutState = {};

var useClientDummy = function useClientDummy() {
  return function () {
    return null;
  };
};

var useClientSave = typeof window !== 'undefined' ? _useClient.default : useClientDummy;

function ShoppingProvider(_ref) {
  var children = _ref.children,
      customer = _ref.customer,
      defaultCurrency = _ref.defaultCurrency,
      defaultViesValid = _ref.defaultViesValid,
      region = _ref.region,
      stockOrderingGroup = _ref.stockOrderingGroup;
  var client = useClientSave('api');

  var _React$useState = _react.default.useState({
    currency: defaultCurrency,
    customer: customer,
    viesValid: defaultViesValid || false,
    checkoutState: defaultCheckoutState,
    isPickUpPointSelected: false
  }),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      ctx = _React$useState2[0],
      setCtx = _React$useState2[1];

  var updateContext = _react.default.useCallback(function (nextCtxPartial) {
    setCtx(function (ps) {
      return (0, _extends2.default)({}, ps, nextCtxPartial);
    });
  }, []);

  var loadShoppingData = _react.default.useCallback( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(pUser) {
      var data, partial;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return client.call('v1.shops.customerShoppingProfile', {
                userId: pUser.id
              }, {
                method: 'post',
                mockAction: 'customerShoppingProfile'
              });

            case 2:
              data = _context.sent;
              partial = {
                customer: data.customer,
                checkoutState: (0, _mapCustomerToCheckout.default)(data.customer)
              };
              updateContext(partial);
              return _context.abrupt("return", partial);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [client, updateContext]);

  return /*#__PURE__*/_react.default.createElement(_ShoppingContext.default.Provider, {
    value: (0, _extends2.default)({}, ctx, {
      noTaxPrices: ctx.viesValid && !ctx.checkoutState.otherDeliveryInfo,
      loadShoppingData: loadShoppingData,
      updateContext: updateContext,
      region: region,
      stockOrderingGroup: stockOrderingGroup
    })
  }, children);
}

process.env.NODE_ENV !== "production" ? ShoppingProvider.propTypes = {
  children: _propTypes.default.node,
  customer: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.string
  }),
  defaultCurrency: _propTypes.default.string.isRequired,
  defaultViesValid: _propTypes.default.bool,
  region: _propTypes.default.string.isRequired,
  stockOrderingGroup: _propTypes.default.string.isRequired
} : void 0;
ShoppingProvider.defaultProps = {
  children: null,
  customer: null
};
var _default = ShoppingProvider;
exports.default = _default;